export const DEALER_DROPDOWN_NAME = 'dealer-dropdown';
export const CUSTOMER_NUMBER_DROPDOWN_NAME = 'customer-number-dropdown';
export const ASSOCIATED_DEALER_DRAWER_ID = 'associated-dealer-drawer';
export const SELECT_CUSTOMER_DRAWER_ID = 'select-customer-drawer';
export const SEARCH_RESULTS_DRAWER_ID = 'search-results-drawer';
export const SELECT_CUSTOMER_FORM_ID = 'select-customer-form';
export const DEALER_SEARCH_FORM_ID = 'dealer-search-form';
export const SEARCH_RESULTS_FORM_ID = 'search-results-form';
export const MO_STORE_LOCATION = 'store-location';
export const CUSTOMER_NUMBER_INPUT_NAME = 'customer-number-input';
export const CUSTOMER_NUMBER_RADIO_NAME = 'customer-number-radio';
export const DEALER_INPUT_ADDRESS = 'dealer-input-address';
export const DEALER_INPUT_CITY = 'dealer-input-city';
export const DEALER_INPUT_ZIP_CODE = 'dealer-input-zip-code';
export const END_USE_CODE_DROPDOWN_NAME = 'end-use-code-dropdown';
export const TERMS_AND_CONDITIONS_CHECKBOX_NAME =
  'terms-and-conditions-checkbox';
export const SKIP_THIS_STEP_CHECKBOX_NAME = 'skip-this-step-checkbox';
export const ORDER_TYPE_RADIO_NAME = 'order-type';
export const DEFAULT_SEARCH_RESULTS_QUANTITY = 6;
export const ERRORS = {
  NO_RESULTS: 'NO_RESULTS',
  NO_SEARCH_VALUES: 'NO_SEARCH_VALUES',
  INVALID_DCN: 'INVALID_DCN'
};
export const EVENT_FORM_SUBMITTED = 'formSubmitted';
export const STATUS_SUCCESS = 'Success';
export const STATUS_FAIL = 'Fail';

export const SELECT_CUSTOMER_FORM_DEFAULT_VALUES = {
  [DEALER_DROPDOWN_NAME]: '',
  [CUSTOMER_NUMBER_DROPDOWN_NAME]: '',
  [MO_STORE_LOCATION]: '',
  [ORDER_TYPE_RADIO_NAME]: '',
  [END_USE_CODE_DROPDOWN_NAME]: '',
  [SKIP_THIS_STEP_CHECKBOX_NAME]: false
};

export const DEALER_FORM_DEFAULT_VALUES = {
  [DEALER_DROPDOWN_NAME]: '',
  [CUSTOMER_NUMBER_INPUT_NAME]: '',
  [DEALER_INPUT_ADDRESS]: '',
  [DEALER_INPUT_CITY]: '',
  [DEALER_INPUT_ZIP_CODE]: ''
};

export const SEARCH_FORM_DEFAULT_VALUES = {
  [CUSTOMER_NUMBER_RADIO_NAME]: ''
};

export const GA_CART_ORTER_INFORMATION_SETTING_FORM = {
  formLocation: 'PCC Shopping cart Page',
  formName: 'Order Information Settings',
  formStatus: 'success',
  formFieldCausingError: 'api failed'
};
